import { useGlobalKeyboardBindings } from "@sfc/ui";
import { focusPageSearch } from "@client/utils/searchShortcut";

const searchBinding = {
  id: "page-search.focus",
  description: "Focus the visible page search",
  keys: ["k"],
  caseSensitive: false,
  modifiers: [
    { metaKey: true, altKey: false, shiftKey: false },
    { ctrlKey: true, altKey: false, shiftKey: false },
  ],
  // The existing handler cancels only after focusing a search or blocking an overlay.
  preventDefault: false,
} as const;

export function SearchShortcut() {
  useGlobalKeyboardBindings({ id: "page-search" }, [
    {
      definition: searchBinding,
      when: (event) => !event.isComposing,
      run: focusPageSearch,
    },
  ]);
  return null;
}
